import Fab, { FabProps } from '@material-ui/core/Fab'
import is from 'typescript-styled-is'
import React from 'react'
import styled, { ITheme } from '../../../../theme'

const Button: React.ComponentType<IButtonProps> = styled(Fab)<IButtonProps>`
  &&& {
    width: 48px;
    height: 48px;

    color: ${(props: ITheme) => props.theme.colors.palette.emerald};
    background-color: white;

    ${is('isExpanded')`
      background-color: ${(props: ITheme) =>
        props.theme.colors.palette.greyishBrown};
      color: #fff;
  `}
  }
`

export default Button

export interface IButtonProps extends FabProps {
  isExpanded?: boolean
}
